import React from "react";
import { Box } from "@mui/material";
import "./Background.css";
import { DASHBOARD_CHROME } from "../helpers/layoutConstants";

// The box no longer reserves bottom padding for the fixed footers (the old
// paddingBottom60 / mobilePadding0 props): useFooterMode moves the footers
// into normal flow when a page scrolls, and any padding below the in-flow
// footer would invert the footer/stepper order at full scroll.
const Background = ({
  children,
  extraSpacing,
  backgroundImg,
  dashboardChrome,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        // dashboardChrome: the page renders an in-flow header above this
        // box and DashboardFooter after it — a full 100vh box would force
        // that much artificial scroll over empty map (see DASHBOARD_CHROME).
        // !important: this sx loses to Background.css (injectFirst) without it.
        minHeight: extraSpacing
          ? "0 !important"
          : dashboardChrome
            ? `calc(100vh - ${DASHBOARD_CHROME}px) !important`
            : "100vh",
      }}
      className={`${backgroundImg ? "payment-layout" : "background-container"}`}
    >
      {/* Content (children) will be rendered here */}
      <div className="content-container">{children}</div>
    </Box>
  );
};

export default Background;
